/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-10-17 16:05:53
 * @LastEditors: linxi
 * @LastEditTime: 2025-10-17 17:06:53
 */
import { API_PREFIX } from './constant'
import { ContentType, MultiPartFormData, Request } from './request'

export interface PatientMemoListParams {
  current?: any
  patientId?: any
  size?: any
}

export function getPatientMemoList(params: PatientMemoListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patientMemo/list`,
    method: 'GET',
    params,
  }
}

export interface PatientMemoDetailParams {
  id?: any
}

export function getPatientMemoDetail(params: PatientMemoDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patientMemo/detail`,
    method: 'GET',
    params,
  }
}

export interface PatientMemoSubmitParams {
  id?: any
  patientId?: any
  title?: any
  content?: any
}

export function getPatientMemoSubmit(body: PatientMemoSubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patientMemo/submit`,
    method: 'POST',
    body,
  }
}

export interface PatientMemoDeleteParams {
  ids?: any
}

export function getPatientMemoDelete(params: PatientMemoDeleteParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patientMemo/del`,
    method: 'GET',
    params,
  }
}

export interface ImportExcelParams {
  file?: any
  tenantId?: string
}


// 备忘录导入 excel
export function getMemorandumExcelFn(params: ImportExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patientMemo/log/importexcel`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}